import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { assetUrl } from 'src/single-spa/asset-url';
import { Store } from '@ngrx/store';
import { SearchCustomersState } from './../../../store/search-customers/search-customers.reducer';
import * as fromSearchCustomersActions from './../../../store/search-customers/search-customers.actions';
import * as fromSearchCustomerSelectors from './../../../store/search-customers/search-customers.selectors';
import { ICustomer } from '@signal/asp-data-commons';
import * as fromSelectors from './../../../store/dealer/dealer.selectors';
import { DealerState } from 'src/app/modules/store/dealer/dealer.reducer';
import { countryCd, environment, isPartsAccessible, isSalesAccessibleFeatureFlag, isServiceAccessibleFeatureFlag, isSpServiceSchedulingOverride } from 'src/app/modules/shared/services/util.service';
import * as util from 'src/app/modules/shared/services/util.service';
@Component({
  selector: 'app-choose-customer',
  templateUrl: './choose-customer.component.html',
  styleUrls: ['./choose-customer.component.scss']
})
export class ChooseCustomerComponent implements OnInit {

  isLoading$!: Observable<boolean>;
  customers$!: Observable<ICustomer[]>;
  dealerCode$: Observable<string>;
  private readonly allAppointmentTypes = [
    {
      image: assetUrl('images/test-drive-bdc.png'),
      text: 'Test Drive',
      link: '/asp/bdc/testdrive'
    },
    // {
    //   image: assetUrl('images/delivery-bdc.png'),
    //   text: 'Delivery',
    //   link: '/asp/bdc/delivery'
    // },
    {
      image: assetUrl('images/service-bdc.png'),
      text: 'Service',
      link: '/asp/bdc/service'
    },
    {
      image: assetUrl('images/parts-bdc.png'),
      text: 'Parts',
      link: '/asp/bdc/parts'
    }
  ];
  isMEXDealer = countryCd === 'MEX';
  
  constructor(
    private readonly searchCustomerStore: Store<SearchCustomersState>,
    private readonly router: Router,
    private readonly dealerState: Store<DealerState>
  ) {
    this.dealerCode$ = this.dealerState.select(fromSelectors.selectDealerCode);
  }

  ngOnInit(): void {
    this.customers$ = this.searchCustomerStore.select(fromSearchCustomerSelectors.selectCustomers);
    this.isLoading$ = this.searchCustomerStore.select(fromSearchCustomerSelectors.selectCustomersLoading);
  }

  get appointmentTypes() {
    return this.allAppointmentTypes.filter(appointmentType => {
      if (appointmentType.text === 'Test Drive') {
        return isSalesAccessibleFeatureFlag;
      }

      else if (appointmentType.text === 'Service') {
        return isServiceAccessibleFeatureFlag || isSpServiceSchedulingOverride;
      }

      else if (appointmentType.text === 'Parts') {
        return environment.enableParts && isPartsAccessible;
      }

      return true;
    });
  }

  selectCustomer(customer: ICustomer) {
    this.searchCustomerStore.dispatch(new fromSearchCustomersActions.LoadCustomer({ customerId: customer?.customerId?.toString() || '' }));
    this.searchCustomerStore.dispatch(new fromSearchCustomersActions.ClearPendingSearchInput());
    this.router.navigate(['/asp/bdc/dashboard']);
  }

  getCustomerDisplayName(customer: ICustomer): string {
    return util.getCustomerDisplayName(customer);
  }

  checkDealerType(dealerCode: string) {
    return dealerCode?.startsWith('6')
      ? 'https://www.lexus.com/My-Lexus/account/create-account/'
      : 'https://www.toyota.com/owners/register/';
  }
}
